export default {
  methods: {
    calPHT() {
      if (document.PHTForm.SI.checked) {
        document.getElementById('phtunit').innerHTML = "&mu;mol/L";
        document.getElementById('albunit').innerHTML = "g/L";
        document.getElementById('cphtunit').innerHTML = "&mu;mol/L";
      } else {
        document.getElementById('phtunit').innerHTML = "&mu;g/mL";
        document.getElementById('albunit').innerHTML = "g/dL";
        document.getElementById('cphtunit').innerHTML = "&mu;g/mL";
      }

      if ((document.PHTForm.pht.value && document.PHTForm.alb.value) != "") {
        var a = parseFloat(document.PHTForm.pht.value);
        var b = parseFloat(document.PHTForm.alb.value);
        var factor = document.PHTForm.crcl.checked ? 0.2 : 0.275;
        var pheny_conv = 1;
        var alb_conv = 1;

        if (document.PHTForm.SI.checked) {
          pheny_conv = 1 / 3.96;
          alb_conv = .1;
        }

        a *= pheny_conv;
        b *= alb_conv;
        var c = a / (factor * b + 0.1);
        c /= pheny_conv;
        document.PHTForm.corrpht.value = c.toFixed(1);
      }
    }

  },
  id: 'e8ee67419a',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=Phenytoin><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>Phenytoin Correction</div></div></div><div class=page-content><form name=PHTForm><div class=block-header>OPTIONS</div><div class="list simple-list"><ul><li><span>SI Unit</span> <label class="toggle toggle-init color-green"><input type=checkbox name=SI @change=calPHT()> <span class=toggle-icon></span></label></li><li><span>Renal CrCl &lt; 20 ml/min</span> <label class="toggle toggle-init color-green"><input type=checkbox name=crcl @change=calPHT()> <span class=toggle-icon></span></label></li></ul></div><div class=block-header>CALCULATION</div><div class="list simple-list"><ul><li><span>Measured phenytoin (<span id=phtunit>&mu;g/mL</span>):</span><div class=item-input style=width:15%;><input name=pht placeholder=enter&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input=calPHT()></div></li><li><span>Serum albumin (<span id=albunit>g/dL</span>):</span><div class=item-input style=width:15%;><input name=alb placeholder=enter&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input=calPHT()></div></li><li><span>Corrected phenytoin (<span id=cphtunit>mg/L</span>):</span><div class=item-input style=width:15%;><input name=corrpht placeholder="" type=number value="" style="text-align: right;"></div></li></ul></div><div class=block-footer>Norm: 10-20 &mu;g/mL or 39-79 &mu;mol/L</div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};